import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { usePreviousPregnanciesChartsDataContext } from './hooks/usePreviousPregnanciesChartsDataContext';

export const PreviousPregnanciesQuantityLiveBirths = () => {
    const { chartData } = usePreviousPregnanciesChartsDataContext();


    return (
        <SimpleBars
            title={'Quantidade de Gestações Anteriores - Nascidos Vivos'}
            horizontal={false}
            subtitles={chartData?.previousPregnanciesQuantityLiveBirths?.map((item) => item.description)}
            values={chartData?.previousPregnanciesQuantityLiveBirths?.map((item) => item.total  ||  0)}
        />
    );
};
